import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchName: "",
  hotelName: "",
  checkIn: "",
  checkOut: "",
  room: [], // keep as "room"
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchName: (state, action) => {
      state.searchName = action.payload;
    },
    setHotelName: (state, action) => {
      state.hotelName = action.payload;
    },
    setCheckIn: (state, action) => {
      state.checkIn = action.payload;
    },
    setCheckOut: (state, action) => {
      state.checkOut = action.payload;
    },
    setRooms: (state, action) => {
      state.room = action.payload;
    },
  },
});

export const {
  setSearchName,
  setHotelName,
  setCheckIn,
  setCheckOut,
  setRooms,
} = searchSlice.actions;

export default searchSlice.reducer;
